var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_6928)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 41C42.7392 41.0004 41.5207 41.4545 40.5672 42.2793C39.6137 43.1041 38.9888 44.2445 38.8068 45.492C38.6248 46.7396 38.8977 48.011 39.5759 49.0738C40.254 50.1367 41.2919 50.92 42.5 51.2806V54.5C42.5 54.8978 42.658 55.2794 42.9393 55.5607C43.2206 55.842 43.6022 56 44 56C44.3978 56 44.7794 55.842 45.0607 55.5607C45.342 55.2794 45.5 54.8978 45.5 54.5V51.2806C46.7081 50.92 47.746 50.1367 48.4241 49.0738C49.1023 48.011 49.3752 46.7396 49.1932 45.492C49.0112 44.2445 48.3863 43.1041 47.4328 42.2793C46.4792 41.4545 45.2608 41.0004 44 41ZM44 48.5C43.555 48.5 43.12 48.368 42.75 48.1208C42.38 47.8736 42.0916 47.5222 41.9213 47.111C41.751 46.6999 41.7064 46.2475 41.7932 45.811C41.88 45.3746 42.0943 44.9737 42.409 44.659C42.7237 44.3443 43.1246 44.13 43.561 44.0432C43.9975 43.9564 44.4499 44.001 44.861 44.1713C45.2722 44.3416 45.6236 44.63 45.8708 45C46.118 45.37 46.25 45.805 46.25 46.25C46.25 46.8467 46.0129 47.419 45.591 47.841C45.169 48.2629 44.5967 48.5 44 48.5ZM59 35H53V30.5C53 28.1131 52.0518 25.8239 50.364 24.136C48.6761 22.4482 46.3869 21.5 44 21.5C41.6131 21.5 39.3239 22.4482 37.636 24.136C35.9482 25.8239 35 28.1131 35 30.5V35H29C28.2044 35 27.4413 35.3161 26.8787 35.8787C26.3161 36.4413 26 37.2044 26 38V59C26 59.7957 26.3161 60.5587 26.8787 61.1213C27.4413 61.6839 28.2044 62 29 62H59C59.7957 62 60.5587 61.6839 61.1213 61.1213C61.6839 60.5587 62 59.7957 62 59V38C62 37.2044 61.6839 36.4413 61.1213 35.8787C60.5587 35.3161 59.7957 35 59 35ZM38 30.5C38 28.9087 38.6321 27.3826 39.7574 26.2574C40.8826 25.1321 42.4087 24.5 44 24.5C45.5913 24.5 47.1174 25.1321 48.2426 26.2574C49.3679 27.3826 50 28.9087 50 30.5V35H38V30.5ZM59 59H29V38H59V59Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_6928",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH3);
export default __webpack_public_path__ + "static/media/h-3.5d7e389d66c55355f7e053fcdc3e75ad.svg";
export { ForwardRef as ReactComponent };